export const ANY_EMPLOYEE = 'any-employee';

export const PAST_RESCHEDULE_DATE = 'past_reschedule_date';
